/**
 * 单页 - 模板路由入口
 * 
 * 根据用户选择的模板ID，加载对应版本的单页组件
 */

import { useTemplate } from "@/context/TemplateContext";

// ============================================
// 导入各模板组件
// ============================================

import ClassicSinglePage from "@/templates/classic/single-page/SinglePage";
import ModernSinglePage from "@/templates/modern/single-page/SinglePage";
import SunsetSinglePage from "@/templates/sunset/single-page/SinglePage";
import PurpleSinglePage from "@/templates/purple/single-page/SinglePage";
import CrystalSinglePage from "@/templates/crystal/single-page/SinglePage";
import DarkSinglePage from "@/templates/classic/single-page/SinglePage"; // TODO: 后续创建深色模板
import GreenSinglePage from "@/templates/classic/single-page/SinglePage"; // TODO: 后续创建绿色模板
import RedSinglePage from "@/templates/classic/single-page/SinglePage"; // TODO: 后续创建红色模板

// ============================================
// 模板映射表
// ============================================

const templateComponents = {
  classic: ClassicSinglePage,
  modern: ModernSinglePage,
  dark: DarkSinglePage,
  green: GreenSinglePage,
  red: RedSinglePage,
  "tech-blue": ClassicSinglePage,
  "deep-blue": ClassicSinglePage,
  teal: ModernSinglePage,
  sunset: SunsetSinglePage,
  purple: PurpleSinglePage,
  crystal: CrystalSinglePage,
};

// ============================================
// 单页组件
// ============================================

export default function SinglePageView() {
  const { templateId } = useTemplate();
  
  // 根据模板ID选择对应组件，默认使用经典模板
  const TemplateComponent = templateComponents[templateId as keyof typeof templateComponents] || ClassicSinglePage;
  
  return <TemplateComponent />;
}
